export default class Clipboard {
  static copyElement(element: Element) {
    const range = document.createRange();
    range.selectNodeContents(element);

    const selection = window.getSelection();
    selection?.removeAllRanges();
    selection?.addRange(range);

    const resultCopy = document.execCommand('copy');
    selection?.removeAllRanges();

    return resultCopy;
  }
}
